import { fetchLuxLoyaltyAccountEligibility } from 'actions/LuxLoyaltyActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLoyaltyUserEligibilityTier(): [
  eligibilityTier: App.LuxLoyaltyTier | undefined,
  eligibilityTierFetching: boolean,
  eligibilityTierError: any,
  ] {
  const dispatch = useAppDispatch()

  const luxLoyaltyEligibility = useAppSelector(state => state.luxLoyalty.eligibilityTier)

  useEffect(() => {
    dispatch(fetchLuxLoyaltyAccountEligibility())
  }, [dispatch])

  return [
    luxLoyaltyEligibility.data,
    !!luxLoyaltyEligibility.fetching,
    luxLoyaltyEligibility.error,
  ]
}

export default useLoyaltyUserEligibilityTier
